import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@zillow/constellation';
import { REPORT_STATUS_REAUTHENTICATING } from '../../../../../constants/statusConstants';

export default function ReauthenticatingAlert({ applicant }) {
  const { backgroundInfo = {}, creditInfo = {}, idVerificationInfo = {} } = applicant;

  return (
    (backgroundInfo.status === REPORT_STATUS_REAUTHENTICATING ||
      creditInfo.status === REPORT_STATUS_REAUTHENTICATING ||
      idVerificationInfo.status === REPORT_STATUS_REAUTHENTICATING) && (
      <Alert body="The reports are currently unavailable. You’ll be able to view the applicant’s reports when they finish with identity verification. Please try again later." />
    )
  );
}

ReauthenticatingAlert.propTypes = {
  applicant: PropTypes.shape({
    backgroundInfo: PropTypes.shape({
      status: PropTypes.string,
    }),
    creditInfo: PropTypes.shape({
      status: PropTypes.string,
    }),
    idVerificationInfo: PropTypes.shape({
      status: PropTypes.string,
    }),
  }),
};
